<template>
  <div class="my-10">
    <h1 class="text-3xl font-bold text-center">{{ __("Clients") }}</h1>
    <div class="bg-white p-4 shadow-md mt-10">
      <div class="max-w-5xl w-full mx-auto my-10 flex flex-col items-center">
        <form class="mt-2" @submit.prevent="submitClientForm">
          <div class="flex flex-wrap -mx-4">
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.first_name" :data-error="error('first_name', 'client')" class="w-full pb-8" :label="__('First name')"/>
            </div>
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.last_name" :data-error="error('last_name', 'client')" class="w-full pb-8" :label="__('Last name')"/>
            </div>

            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.email" :data-error="error('email', 'client')" class="w-full pb-8" :label="__('Email')"/>
            </div>
            <div class="px-4 w-full sm:w-1/2">
              <text-input v-model="form.phone" :data-error="error('phone', 'client')" class="w-full pb-8" :label="__('Phone')"/>
            </div>

            <div class="px-4 w-full">
              <text-input v-model="form.address" :data-error="error('address', 'client')" class="w-full pb-8" :label="__('Address')"/>
            </div>

            <div class="px-4 w-full flex justify-center items-center">
              <loading-button :loading="sendingClientForm" class="btn-primary" type="submit">
                {{ __("Salveaza client") }}
              </loading-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import TextInput from '@/Shared/TextInput';
  import LoadingButton from '@/Shared/LoadingButton';
  import Icon from '@/Shared/Icon';
  import {format} from 'date-fns';

  export default {
    layout: Layout,
    metaInfo() {
      return {
        title: this.__("Add client"),
      }
    },
    data() {
      return {
        datePickerLocale: window.datePickerLocale,
        sendingClientForm: false,
        form: {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          address: '',
        }
      }
    },
    components: {
      Layout,
      TextInput,
      LoadingButton,
      Icon
    },
    methods: {
      submitClientForm() {
        let data = new FormData();
        data.append('first_name', this.form.first_name || '');
        data.append('last_name', this.form.last_name || '');
        data.append('email', this.form.email || '');
        data.append('phone', this.form.phone || '');
        data.append('address', this.form.address || '');
        data.append('job_id', this.$page.props.request.job || '');
        data.append('registrationNumber', this.$page.props.request.registrationNumber || '');

        this.sendingClientForm = true;
        this.$inertia.post(this.route('clients.store'), data)
          .then(() => this.sendingClientForm = false);
      }
    }
  }
</script>
